import { CompanyAction, CompanyState } from 'store/data/company';
import { domainUtility } from 'utility';

const initialState: CompanyState = { allIds: [], byId: {} };

const companyReducer = (
  state: CompanyState = initialState,
  action: CompanyAction,
): CompanyState => {
  switch (action.type) {
    case 'data/company/ADD':
      return domainUtility.add(state, action.payload);
    case 'data/company/SET':
      return domainUtility.set(state, action.payload);
    case 'data/company/UPDATE':
      return domainUtility.update(state, action.payload);
    case 'data/company/REMOVE':
      return domainUtility.remove(state, action.payload);
    case 'data/company/SET_DOMAIN': {
      const { allIds, byId } = action.payload;
      return { allIds, byId };
    }
    default:
      return state;
  }
};

export default companyReducer;
